import PosthogService from '~/services/posthog/PosthogService';

export function fireMenuBarDashboardClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:dashboard_clicked');
}
